import { request } from '@/utils/ajax';
import { ResidentialUnitGroup } from '@/types';

interface ResidentialUnitGroupUpdateRequest {
    id?: number;
    name: string;
    projectId: number;
    constructionPhaseId: number | null;
}

export function getResidentialUnitGroup(residentialUnitGroupId: number): Promise<ResidentialUnitGroup> {
    return request(`api/residential-unit-group/${residentialUnitGroupId}`).then((x) => x.json());
}

export function getResidentialUnitGroupsByProjectId(projectId: number): Promise<ResidentialUnitGroup[]> {
    return request(`api/project/${projectId}/residential-unit-groups`).then((x) => x.json());
}

function createResidentialUnitGroup(residentialUnitGroup: ResidentialUnitGroupUpdateRequest): Promise<ResidentialUnitGroup> {
    return request(`api/residential-unit-group`, {
        method: 'POST',
        json: true,
        body: residentialUnitGroup,
    }).then((x) => x.json());
}

function updateResidentialUnitGroup(
    residentialUnitGroupId: number,
    residentialUnitGroup: ResidentialUnitGroupUpdateRequest
): Promise<ResidentialUnitGroup> {
    return request(`api/residential-unit-group/${residentialUnitGroupId}`, {
        method: 'PUT',
        json: true,
        body: residentialUnitGroup,
    }).then((x) => x.json());
}

export function createOrUpdateResidentialUnitGroup(
    residentialUnitGroup: ResidentialUnitGroupUpdateRequest
): Promise<ResidentialUnitGroup> {
    return residentialUnitGroup.id
        ? updateResidentialUnitGroup(residentialUnitGroup.id, residentialUnitGroup)
        : createResidentialUnitGroup(residentialUnitGroup);
}

export function deleteGroup(residentialUnitGroupId: number) {
    return request(`api/residential-unit-group/${residentialUnitGroupId}`, {
        method: 'DELETE',
    });
}